export { default } from "./MarkdownTextAreaV2";
export type { ToolbarButton } from "./MarkdownTextAreaV2";
